import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { IVehiclePayload, VehiclesHttpService } from './vehicles.http.service';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService {
  
  constructor(private vehiclesHttpService: VehiclesHttpService) {}

  async getSetupVehicles(routeId: number) {
    const source$ = this.vehiclesHttpService.getSetupVehicles(routeId);
    const vehicles = await lastValueFrom(source$);
    return vehicles;
  }

  async filterVehicles(
    page: number,
    size: number,
    clientsSelected: number[],
    operatorsSelected: number[],
    active?: boolean,
    searchValue?: string
  ) {
    const source$ = this.vehiclesHttpService.filterVehicles(
      page, size, clientsSelected, operatorsSelected, active, searchValue,
    );
    const response: any = await lastValueFrom(source$);
    return response?.data;
  }

  async getVehicles(clientId?: number) {
    const source$ = this.vehiclesHttpService.getVehicles(clientId);
    const vehicles = await lastValueFrom(source$);
    return vehicles;
  }

  async createVehicle(payload: IVehiclePayload) {
    const source$ = this.vehiclesHttpService.createVehicle(payload);
    const vehicle = await lastValueFrom(source$);
    return vehicle;
  }

  async updateVehicle(vehicleId: number, payload: IVehiclePayload) {
    const source$ = this.vehiclesHttpService.updateVehicle(vehicleId, payload);
    const vehicle = await lastValueFrom(source$);
    return vehicle;
  }
}
